import React, { useEffect } from 'react';

interface ContactFormProps {
  formId: string;
}

const ContactForm: React.FC<ContactFormProps> = ({ formId }) => {
  useEffect(() => {
    // יצירת תגית script להטמעת הטופס
    const script = document.createElement('script');
    script.src = 'https://server.fillout.com/embed/v1/';
    script.async = true;
    
    // הוספת הסקריפט לדף
    document.body.appendChild(script);
    
    // ניקוי בעת הסרת הקומפוננטה
    return () => {
      // מנסים להסיר את הסקריפט אם עדיין קיים
      if (document.body.contains(script)) {
        document.body.removeChild(script);
      }
    };
  }, []);

  return (
    <section id="contact" className="py-16 bg-gray-50">
      <div className="section-container">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold mb-4">רוצה שאחזור אליך? זה המקום להשאיר פרטים</h2>
        
        </div>
        
        <div className="max-w-3xl mx-auto">
          {/* הטמעת הטופס באמצעות הקוד הרשמי של Fillout */}
          <div 
            style={{ width: '100%', height: '500px' }} 
            data-fillout-id={formId} 
            data-fillout-embed-type="standard"
            data-fillout-inherit-parameters
            data-fillout-dynamic-resize
          ></div>
        </div>
      </div>
    </section>
  );
};

export default ContactForm;